package org.moxultimate.topwithmox.components.crud

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.moxultimate.topwithmox.theme.DarkTextColor
import org.moxultimate.topwithmox.theme.FontFamily

/**
 * Labelled text input shared across all CRUD forms.
 *
 * @param label         Label text rendered above the input.
 * @param value         Current field value.
 * @param placeholder   Hint text shown when the field is empty.
 * @param readOnly      Renders non-editable (grayed cursor, WhiteSmoke bg) when true.
 * @param onValueChange Callback invoked on every keystroke (ignored when [readOnly]).
 */
@Composable
fun CRUDFormField(
    label: String,
    value: String,
    placeholder: String,
    readOnly: Boolean = false,
    onValueChange: (String) -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(6.px),
    ) {
        SpanText(
            text = label,
            modifier = Modifier
                .fontFamily(FontFamily)
                .fontSize(12.px)
                .fontWeight(FontWeight.SemiBold)
                .color(Colors.Gray)
                .styleModifier { property("text-transform", "uppercase") }
                .letterSpacing(0.5.px),
        )
        Input(
            type = InputType.Text,
            value = value,
            onValueChange = { if (!readOnly) onValueChange(it) },
            placeholder = placeholder,
            modifier = Modifier
                .fillMaxWidth()
                .height(44.px)
                .padding(leftRight = 14.px)
                .backgroundColor(if (readOnly) Colors.WhiteSmoke else Colors.White)
                .border(1.px, LineStyle.Solid, Colors.LightGray)
                .borderRadius(10.px)
                .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
                .fontFamily(FontFamily)
                .fontSize(14.px)
                .color(if (readOnly) Colors.Gray else DarkTextColor)
                .styleModifier { if (readOnly) property("cursor", "default") },
        )
    }
}
